import script from "./RiskDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./RiskDashboard.vue?vue&type=script&setup=true&lang=js"

import "./RiskDashboard.vue?vue&type=style&index=0&id=453047b9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-453047b9"]])

export default __exports__